export interface TrackVisitPayload {
  referrer?: string | null;
  utm_source?: string | null;
  country?: string | null;
  device?: string | null;
  occurred_at?: string | null;
  user_id?: string | null;
}

const TRACK_VISIT_ENDPOINT = '/api/track-visit';

export async function trackVisit(payload: TrackVisitPayload): Promise<void> {
  if (typeof window === 'undefined') return;

  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (typeof payload.user_id === 'string' && payload.user_id) {
      headers['x-user-id'] = payload.user_id;
    }

    const response = await fetch(TRACK_VISIT_ENDPOINT, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorBody = await response.text().catch(() => null);
      console.debug('[track-visit] request failed', {
        status: response.status,
        body: errorBody,
      });
    }
  } catch (error) {
    console.debug('[track-visit] request error', error);
  }
}
